<template>
  <div>
    <v-container v-if="saleCompany[0]">
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class="title">机构名称：{{ saleCompany[0].company_title }}</div>
            <div class="title">管理规模：{{ saleCompany[0].scale }}</div>
            <div class="title">办公地址：{{ saleCompany[0].address }}</div>
            <div class="title">公司性质：{{ saleCompany[0].type }}</div>
            <div class="title">成立日：{{ saleCompany[0].estabilsh_date }}</div>
          </div>
        </v-card-title>
      </v-card>
    </v-container>
    <v-data-table :headers="headers" :items="saleCompany" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td class="text-xs-center">
          <router-link :to="`/sale/${props.item.id}`">
            {{ props.item.title }}
          </router-link>
        </td>
        <td class="text-xs-center">{{ props.item.type }}</td>
        <td class="text-xs-center">{{ props.item.scale }}</td>
        <td class="text-xs-center" style="1000px">
          <v-rating v-model="props.item.rating" background-color="orange lighten-3" color="orange" small readonly></v-rating>
        </td>
        <td class="text-xs-center">{{ props.item.value }}</td>
        <td class="text-xs-center">{{ props.item.recent_value }}</td>
        <td class="text-xs-center">{{ props.item.unit_value }}</td>
        <td class="text-xs-center">{{ props.item.recent_unit_value }}</td>
        <td class="text-xs-center">{{ props.item.cumulative_value }}</td>
        <td class="text-xs-center">{{ props.item.recent_cumulative_value }}</td>
        <td class="text-xs-center">{{ props.item.estabilsh_date }}</td>
        <td class="text-xs-center">
          <router-link :to="`/saleMemberInfo/${props.item.sale_member_id}`">
            {{ props.item.name }}
          </router-link>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      // table
      headers: [
        { text: '基金代码', align: 'center', value: 'code' },
        { text: '基金名称', align: 'center', value: 'title' },
        { text: '基金类型', align: 'center', value: 'type' },
        { text: '基金规模', align: 'center', value: 'scale' },
        { text: '基金评级', align: 'center', value: 'rating' },
        { text: '净值估算', align: 'center', value: 'value' },
        { text: '最近净值', align: 'center', value: 'recent_value' },
        { text: '单位净值', align: 'center', value: 'unit_value' },
        { text: '单位最近净值', align: 'center', value: 'recent_unit_value' },
        { text: '累计净值', align: 'center', value: 'cumulative_value' },
        {
          text: '累计最近净值',
          align: 'center',
          value: 'recent_cumulative_value'
        },
        { text: '成立日', align: 'center', value: 'estabilsh_date' },
        { text: '基金经理', align: 'center', value: 'name' }
      ],
      route_id: this.$route.params && this.$route.params.id,
      device: 'desktop'
    }
  },
  computed: mapGetters({
    saleCompany: 'saleCompany'
  }),
  created() {
    this.fetchData()

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch(GetSaleCompany, this.route_id)
    }
  }
}
</script>
